import React from 'react';
import PropTypes from 'prop-types';
import LocationTileSkeleton from './LocationTileSkeleton';

/**
 * Grid of skeleton location tiles shown during loading.
 * Uses the same CSS classes as wsm-tiles grid layout so skeletons
 * match the exact size/spacing of real tiles.
 */
const LocationTileSkeletonGrid = ({ count = 6 }) => (
	<div
		className="tiles tiles-lg tiles-location tiles-layout-grid justify-content-center"
		data-testid="skeleton-grid"
	>
		{Array.from({ length: count }, (_, i) => (
			<LocationTileSkeleton key={`skeleton-tile-${i}`} />
		))}
	</div>
);

LocationTileSkeletonGrid.propTypes = {
	count: PropTypes.number
};

export default LocationTileSkeletonGrid;
